import * as PropTypes from 'prop-types';
import * as React from 'react';
import Pill from './pill';

const OperatingSystemSearchPill = ({ traitValue, changeOperatingSystem }) => {
  if (!traitValue) { return false; }

  return <Pill value={traitValue.name} onClick={() => changeOperatingSystem(null)} />;
};

OperatingSystemSearchPill.propTypes = {
  traitValue: PropTypes.object,
  changeOperatingSystem: PropTypes.func.isRequired,
};

export default OperatingSystemSearchPill;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/search_pills/operating_system_search_pill.jsx